import assignToThis from '../../../helper/assignToThis';
export class ScenarioStructureFinance {

  public crowdfunding: boolean | null = null;
  public linearDepreciationParticipative: boolean | null = null;
  public percentageOfCapex: number | null = null;
  public coShareholder1: boolean | null = null;
  public percentageOwnershipCoShareholder1: number | null = null;
  public coShareholder2: boolean | null = null;
  public percentageOwnershipCoShareholder2: number | null = null;
  public perRenSoldFarmDown: number | null = null;
  public minDSCR1: number | null = null;
  public minDSCR2: number | null = null;
  public minDSCR3: number | null = null;
  public maxBankDebtPercentage: number | null = null;

  public constructor(obj: object = {}) {
    assignToThis(this, obj);
  }

}
